import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Unauthorized page component - Modern, beautiful, English, CSS only
 */
const Unauthorized = () => {
  const { authenticated, userProfile, logout } = useAuth();

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-icon">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="30" stroke="#e74c3c" strokeWidth="4" fill="#fff" />
          <path d="M22 22 L42 42 M42 22 L22 42" stroke="#e74c3c" strokeWidth="4" strokeLinecap="round" />
        </svg>
      </div>
      <div className="unauthorized-title">Access Denied</div>
      <div className="unauthorized-desc">
        {authenticated ? (
          <>
            <div style={{ marginBottom: 8 }}>
              You are logged in as <strong>{userProfile?.username || 'User'}</strong>
              {userProfile?.roles && userProfile.roles.length > 0 && (
                <>
                  {' '}with roles:
                  <ul className="role-list" style={{ display: 'inline-block', marginLeft: 8 }}>
                    {userProfile.roles.map((role) => (
                      <li key={role} className="role-badge" style={{ display: 'inline-block', marginRight: 6 }}>{role}</li>
                    ))}
                  </ul>
                </>
              )}
            </div>
            <div>Your current roles do not have permission to access this page.</div>
          </>
        ) : (
          <>You are not logged in. Please log in to access this page.</>
        )}
      </div>
      <div style={{ display: 'flex', gap: 14, justifyContent: 'center', margin: '18px 0 0 0' }}>
        {authenticated ? (
          <>
            <Link to="/" className="unauthorized-btn">Back to Home</Link>
            <button onClick={logout} className="unauthorized-btn unauthorized-btn-secondary">Logout</button>
          </>
        ) : (
          <Link to="/login" className="unauthorized-btn">Login</Link>
        )}
      </div>
      <div className="unauthorized-illustration">
        <svg width="180" height="120" viewBox="0 0 180 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="90" cy="100" rx="70" ry="12" fill="#e74c3c" />
          <rect x="60" y="50" width="60" height="30" rx="8" fill="#f0f0f0" stroke="#e74c3c" strokeWidth="3" />
          <path d="M75 65 L105 65" stroke="#e74c3c" strokeWidth="4" strokeLinecap="round" />
          <circle cx="90" cy="65" r="5" fill="#e74c3c" />
        </svg>
      </div>
    </div>
  );
};

export default Unauthorized;